import {
  navigate,
  sendGetRequest,
  formatDate,
  sendDeleteRequest,
  allowedOperations,
  sendPostRequest,
  sendPatchRequest,
} from "../utils/utils";
import DataList from "./component/@list/list";
import { useState, useEffect } from "react";
import AppRoutes from "../routing/routes";
import { coreStyles } from "../theme/style";
import {
  Box,
  Button,
  ButtonGroup,
  Icon,
  DialogContent,
  Dialog,
  DialogActions,
  DialogTitle,
  Grid,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  Paper,
  TableBody,
  IconButton,
} from "@mui/material";
import EasyTextEdit from "./component/text-edit";
import DataListWithSearch from "./component/@list/list-search";

const getTableHead = () => {
  return [
    { id: "createAt", label: "Added on", alignRight: false },
    { id: "name", label: "Name", alignRight: false },
    { id: "code", label: "Code", alignRight: false },
    { id: "seasons", label: "Seasons", alignRight: false },
    { id: "episodes", label: "Episodes", alignRight: false },
    { id: "segments", label: "segments", alignRight: false },
    { id: "_", alignRight: false },
  ];
};

const segmentRef = {
  uuid: undefined,
  name: "",
  code: "",
};

const ShowList = () => {
  const [dataList, setDataList] = useState([]);
  const [loading, onLoading] = useState(false);
  const { canEdit, canDelete, canCreate } = allowedOperations();
  const [showSegmentDialog, setShowSegmentDialog] = useState(false);
  const appStyle = coreStyles();
  const [segment, setSegment] = useState(segmentRef);
  const [segments, setSegments] = useState([]);
  const [deletedSegment, setDeletedSegment] = useState([]);

  const onValueChange = (value, tag) => {
    setSegment({ ...segment, [tag]: value });
  };

  const actionOptions = [
    canDelete
      ? {
          icon: "delete",
          value: "delete",
          label: "Delete",
          onClick: (value, selected) => {
            onLoading(true);
            Promise.all(
              selected.map((uuid) => sendDeleteRequest("shows", uuid)),
            ).then((response) => {
              executeFetch();
            });
          },
        }
      : null,
    canEdit
      ? {
          icon: "edit_note",
          value: "edit",
          label: "Edit",
          onClick: (_value, selected) =>
            navigate(
              `${AppRoutes.shows}/${AppRoutes.show}?uuid=${selected.join("")}`,
              true,
            ),
        }
      : null,
  ].filter(Boolean);
  const filterOptions = [];

  const executeFetch = (refresh = false) => {
    sendGetRequest(
      "shows",
      (loading) => onLoading(loading),
      (data) => setDataList(data),
    );
  };

  useEffect(() => {
    executeFetch();
    fetchSegments();
    // eslint-disable-next-line
  }, []);

  const createUpdateSegmet = () => {
    onLoading(true);
    if (segment.uuid) {
      const { uuid, ...rest } = segment;
      sendPatchRequest(
        `segments/${uuid}`,
        { ...rest },
        (loading) => null,
        (data) => {
          setSegment(segmentRef);
          fetchSegments();
        },
      );
      return;
    }
    sendPostRequest(
      "segments",
      { ...segment },
      (loading) => null,
      (data) => {
        setSegment(segmentRef);
        fetchSegments();
      },
    );
  };

  const fetchSegments = () => {
    sendGetRequest(
      "segments",
      (loading) => onLoading(loading),
      (data) => {
        setSegments(data);
        onLoading(false);
      },
    );
  };

  const btnGroupOptions = [
    { label: "Segments", destination: `${AppRoutes.shows}/segments` },
  ];

  const startEdit = (uuid) =>
    navigate(
      `${AppRoutes.shows}/${AppRoutes.show}${uuid ? `?uuid=${uuid}` : ""}`,
      true,
    );


  const saveSegmentChanges = () => {
    if(deletedSegment.length){
      onLoading(true);
      Promise.all(
        deletedSegment.map((uuid) => sendDeleteRequest("segments", uuid)),
      ).then((response) => {
        setDeletedSegment([]);
        fetchSegments();
        onLoading(false);
        setShowSegmentDialog(false);
      });
    }
  }

  return (
    <div>
      <DataListWithSearch
        sectionTitle="Content Shows"
        createNewLabel={canCreate ? "Add Show" : null}
        data={dataList}
        primaryKey="uuid"
        orderColumn="name"
        emptyIcon="playlist_play"
        avatarKey="_"
        loading={loading}
        onBack={() => navigate(`${AppRoutes.contents}`, true)}
        createNewElement={
          canCreate ? (
            <Box sx={{ display: "flex", flexDirection: "row" }}>
              <ButtonGroup size="large" aria-label="large button group">
                {btnGroupOptions.map((btn) => {
                  return (
                    <Button
                      key={btn.destination}
                      onClick={() => setShowSegmentDialog(true)}
                    >
                      {btn.label}
                    </Button>
                  );
                })}
              </ButtonGroup>
              <Button
                variant="contained"
                onClick={() => startEdit()}
                className={appStyle.actionButonCustom}
                startIcon={
                  <Icon children={"add"} className={appStyle.actionButonIcon} />
                }
              >
                {"Add Show"}
              </Button>
            </Box>
          ) : null
        }
        headers={getTableHead()}
        rowData={(data) => {
          const _entries = [
            {
              value: formatDate(data.createdAt, "hh:mm A  MMM DD, YYYY"),
              width: 250,
            },
            { value: data.name, width: 200 },
            { value: data.code },
            { value: data.seasons, align: 'center' },
             { value: data.episodes, align: 'center' },
             { value: data.segments.length > 0 ? data.segments.map((segment) => segment.name).join(', ') : "No segments", width: 200 },
          ];
          return {
            exclude: [],
            entries: _entries,
          };
        }}
        selectionOptions={actionOptions.filter((option) => option.value === "delete")}
        filterOptions={filterOptions}
        optionItems={actionOptions}
      />

      <Dialog open={showSegmentDialog} fullWidth maxWidth={"sm"}>
        <DialogTitle sx={{ pt: 4 }}> Manage Segments </DialogTitle>
        <DialogContent>
          <Box sx={{ width: "100%", bgcolor: "background.paper" }}>
            <Grid container spacing={2} sx={{ mt: 1 }}>
              <Grid item md={5} xs={12}>
                <EasyTextEdit
                  label="Segment name"
                  placeholder="i.e Alphabets"
                  type="text"
                  id="name"
                  errorText=""
                  textField={true}
                  disabled={loading}
                  value={segment.name}
                  onChange={onValueChange}
                />
              </Grid>

              <Grid item md={3} xs={12}>
                <EasyTextEdit
                  label="Code"
                  placeholder="i.e A"
                  type="text"
                  id="code"
                  errorText=""
                  textField={true}
                  disabled={loading}
                  value={segment.code}
                  onChange={onValueChange}
                />
              </Grid>

              <Grid item md={4} xs={12}>
                <Button
                  className={appStyle.actionButon}
                  sx={{ mt: 1 }}
                  disabled={loading || !segment.name || !segment.code}
                  variant="contained"
                  onClick={() => createUpdateSegmet()}
                >
                  {segment.uuid ? "Update Segment" : "Create Segment"}
                </Button>
              </Grid>

              <Grid item md={12} xs={12}>
                <TableContainer component={Paper}>
                  <Table sx={{ minWidth: 250 }} aria-label="segment table">
                    <TableHead>
                      <TableRow>
                        <TableCell>Segment</TableCell>
                        <TableCell align="right">Code</TableCell>
                        <TableCell align="right"></TableCell>
                        <TableCell align="right"></TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {segments.filter((row) => !deletedSegment.includes(row.uuid)).map((row) => (
                        <TableRow
                          key={row.name}
                          sx={{
                            "&:last-child td, &:last-child th": { border: 0 },
                          }}
                        >
                          <TableCell component="th" scope="row">
                            {row.name}
                          </TableCell>
                          <TableCell align="right">{row.code}</TableCell>
                          <TableCell align="right">
                            <IconButton
                              onClick={() => {
                                setSegment(row);
                              }}
                            >
                              <Icon children={"edit"} />
                            </IconButton>
                            <IconButton
                            sx={{ml: 3}}
                            variant="contained"
                              onClick={() => setDeletedSegment([...deletedSegment, row.uuid])}
                            >
                              <Icon children={"delete"} />
                            </IconButton>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Grid>
            </Grid>
          </Box>
        </DialogContent>
        <DialogActions sx={{ pb: 4, pr: 4 }}>
          <Button onClick={() => setShowSegmentDialog(false)}>Dismiss</Button>
          {(deletedSegment.length > 0) && (
            <Button onClick={() => saveSegmentChanges()}>Save Changes</Button>
          )}

          {(deletedSegment.length > 0) && (
            <Button onClick={() => setDeletedSegment([])}>Undo Changes</Button>
          )}
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default ShowList;
